module.exports = __webpack_public_path__ + "static/img/alipay.7a53a77.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/alipay.jpg
// module id = bWFR
// module chunks = 0